import React from 'react'

import { AverageOfficeActionsOverTime, Charts, TransformLine } from '../types'
import { ChartProps } from '../types'
import LineChart from './LineChart'
import LineChartSkeletonLoader from './LineChartSkeletonLoader'
import PlatformChartContainer from './PlatformChartContainer'

const transform: TransformLine<AverageOfficeActionsOverTime> = (datum) =>
  datum.map(({ data, ...item }) => ({
    ...item,
    data: data
      .sort((current, next) => current.year - next.year)
      .map(({ officeActions, year }) => ({
        x: year,
        y: officeActions,
      })),
  }))

const AverageOfficeActions: React.FC<ChartProps> = (props) => (
  <PlatformChartContainer
    chart={Charts.AverageOfficeActionsOverTime}
    exportableConfig={{
      filename: 'average_office_actions_to_disposition',
      getData: (data) => {
        const years = data[0].data.map(({ year }) => year)

        return data.map((item) => {
          const datapoints = years.map((year) =>
            item.data.find(({ year: datumYear }) => year === datumYear)
          )

          return [
            item.id,
            ...datapoints.map((datapoint) => (datapoint ? datapoint.officeActions : '')),
          ]
        })
      },
      getHeader: (data) => data[0].data.map(({ year }) => year),
    }}
    skeleton={LineChartSkeletonLoader}
    title="Average Office Actions to Disposition"
    {...props}
  >
    {({ data: raw, ...dimensions }) => {
      const data = transform(raw)

      return (
        <LineChart
          {...dimensions}
          axisBottom={{
            legend: 'Disposition Year',
          }}
          axisLeft={{
            legend: 'Office Actions',
          }}
          data={data}
          tooltipFormat="1.1f"
        />
      )
    }}
  </PlatformChartContainer>
)

export default AverageOfficeActions
